import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { setAuthHeader } from "@/api/service"
import { ROUTES } from "@/helpers/routes"
import { useAppDispatch } from "@/store"
import { setIsAuthorized } from "@/store/slices/player"
import { parseOAuthTokens } from "./helpers"

export const OAuthCallback = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const [tokens] = useState(() => parseOAuthTokens(window.location.hash))

  useEffect(() => {
    if (!tokens) {
      navigate(ROUTES.OAUTH_ERROR, { replace: true })
      return
    }

    setAuthHeader(tokens.accessToken, tokens.refreshToken)
    dispatch(setIsAuthorized(true))
    navigate(ROUTES.HOME, { replace: true })
  }, [tokens, navigate, dispatch])

  return <div role="status">{t("common.loading")}</div>
}
